import {
	HttpErrorResponse,
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest,
	HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { AuthService } from '../auth/service/auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
	constructor(private router: Router,
				private authService: AuthService) {}

	intercept(
		request: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		return next.handle(request).pipe(
			tap(
				(event: HttpEvent<any>) => {
					/* client-side error */
					if (event instanceof HttpResponse) {
						if (event.body) {
							switch (event.body.status) {
								case 400:
									console.warn(event.body.message);
									break;

								case 401:
									this.authService.unauthorized();
									break;

								case 403:
									this.authService.unauthorized();
									break;
		
							}
						}
					}
				},
				(err: any) => {
					/* server-side error */
					if (err instanceof HttpErrorResponse) {
						switch (err.status) {
							case 400:
								console.warn(err.error.message);
								break;

							case 401:
								Swal.fire({
									icon: 'warning',
									text: err.error.message || err.error.data,
								});	
								this.authService.unauthorized();							
								break;
						}
					}
				}
			)
		);
	}
}
